<!-- 
CustomerList080DataTable.vue
功能：(試點)高潛力名單DataTable
作者：i94004V014 Hugo
完成：2026-10-01
-->
<template>
  <section class="newTable">
    <table class="table datatable table-striped area-list-datatable" id="RemoteDocumentWarningDataTable">
      <thead>
        <tr>
          <th width="120">
            <div class="checkbox checkbox-inline mr-0">
              <input @click="clickTarget = clickTarget == `clickAll` ? `clickAll-again` : `clickAll`" type="checkbox"
                name="check-all" id="check-all" value="1" v-model="checkAll" />
              <label for="check-all"></label>
            </div>
            <span>#</span>
          </th>
          <th width="*"
            :class="'sorting ' + (order.fieldName == 'name' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
            @click="columnSorting('name')">
            姓名
          </th>
          <th width="*"
            :class="'sorting ' + (order.fieldName == 'birthday' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
            @click="columnSorting('birthday')">生日
          </th>
          <th width="200"
            :class="'sorting ' + (order.fieldName == 'addr' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
            @click="columnSorting('addr')">地址
          </th>
          <th width="140"
            :class="'sorting ' + (order.fieldName == 'tag_crm' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
            @click="columnSorting('tag_crm')">
            行為標籤
          </th>
          <th width="140"
            :class="'sorting ' + (order.fieldName == 'tag_interest' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
            @click="columnSorting('tag_interest')">
            興趣標籤
          </th>
          <th 
            :class="'sorting ' + (order.fieldName == 'tag_claim' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
            @click="columnSorting('tag_claim')">
            近三個月<br>家戶理賠
          </th>
          <th 
            :class="'sorting ' + (order.fieldName == 'tag_group_mkt' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
            @click="columnSorting('tag_group_mkt')">
            建議申辦服務
          </th>
          <th width="148">排訪</th>
        </tr>
      </thead>
      <tbody class="block-height" :style="{ height: height + 'px' }">
        <tr v-for="(d, did) in tableDataBackup" :key="`RemoteDocumentWarningDataTable-table-td-${did}`">
          <td width="120">
            <div style="min-height: 30px;">
              <div class="mr-0 checkbox checkbox-inline">
                <input @click="clickTarget = clickTarget == `td-${did}` ? `td-${did}-again` : `td-${did}`"
                  type="checkbox" name="`td-item[]`" :id="`RemoteDocumentWarningDataTable-check-${did}`" :value="d"
                  v-model="selection" :disabled="d.id === ''" @change="$emit('update', selection)" />
                <label :for="`RemoteDocumentWarningDataTable-check-${did}`"></label>
              </div>
              <span>
                <span class="no">{{ did + 1 }}</span>
                <span class="info text-center">
                  <avatar :gender="Number(d.sex)" :size="20" />
                </span>
              </span>
            </div>
          </td>
          <td>
            <Tooltip :position="did < 3 ? 'bottom' : 'top'" :name="d.name" :id="d.id" :mobile="d.mobile" :birthday="d.birthday">
              <a v-if="d.is_exist" class="text-green text-underline pointer-cursor"
                @click="routerToCust(d.id, d.name)">{{ d.name | getMaskName }}</a>
              <a v-else>{{ d.name | getMaskName }}</a>
            </Tooltip>
          </td>
          <!-- 生日 -->
          <td>{{ d.birthday | dateFormat | getMaskBirthday }}</td>
          <!-- 地址 -->
          <td width="200">{{ d.addr | getMaskAddress}}</td>
          <!-- 行為標籤 -->
          <td width="140">{{ d.infos.tag_crm }}</td>
          <!-- 興趣標籤 -->
          <td width="140">{{ d.infos.tag_interest }}</td>
          <!-- 近三個月家戶理賠 -->
          <td>{{ d.infos.tag_claim }}</td>
          <!-- 建議申辦服務 -->
          <td>{{ d.infos.tag_group_mkt }}</td>
          <!-- 排訪 -->
          <td v-if="isBox" :width="iPadWidth">
            <button v-if="!d.visit.csidno" class="btn btn-primary" @click="callBoxVisit(d)"
              v-html="'<span style=\'font-size:1.25rem\'>預約<span>'"></button>
            <button v-else class="btn btn-primary" style="font-size:0.8rem;" @click="callBoxVisit(d)">
              {{ d.visit.str_date | dateFormat }}
              <br />
              {{ d.visit.str_time }}
            </button>
          </td>
          <td v-else :width="iPadWidth">
            <button v-if="!d.visit.csidno" class="btn btn-primary" @click="$emit('scheduled-access', d)"
              v-html="'<span style=\'font-size:1.25rem\'>預約<span>'"></button>
            <button v-else class="btn btn-primary" style="font-size:0.8rem;" @click="$emit('scheduled-access', d)">
              {{ d.visit.str_date | dateFormat }}
              <br />
              {{ d.visit.str_time }}
            </button>
          </td>
        </tr>
        <tr v-if="tableDataBackup.length == 0">
          <td colspan="11" class="text-center pt-3 pb-5">
            <h3>無客戶名單資料</h3>
          </td>
          <td style="display: none;"></td>
          <td style="display: none;"></td>
          <td style="display: none;"></td>
          <td style="display: none;"></td>
          <td style="display: none;"></td>
          <td style="display: none;"></td>
          <td style="display: none;"></td>
          <td style="display: none;"></td>
          <td style="display: none;"></td>
        </tr>
      </tbody>
    </table>
    <!-- 整合地址查詢 -->
    <index-integrated-address-modal :open="IndexIntegratedAddressModalOpen" :address-data="addressData"
      @close="panelClose('IndexIntegratedAddressModalOpen')" />
  </section>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import IndexIntegratedAddressModal from "../../IndexIntegratedAddressModal";
import Avatar from "@/components/Avatar";
import { queryBelowEstrangePolicyContactInfo } from "@/service";
import { commonMixin } from "@/mixins/common";
import { setTimeout } from "timers";
import Tooltip from "@/desktop/components/ToolTip";

const is_iPad = navigator.userAgent.match(/iPad/i) != null; // 確認裝置是否為 iPad
let idmarkWidth = 148;
if (is_iPad) {
  idmarkWidth = 131;
}

export default {
  name: "RemoteDocumentWarningDataTable",
  mixins: [commonMixin],
  components: { Avatar, IndexIntegratedAddressModal, Tooltip },
  props: {
    tableData: {
      type: Array,
      default: () => {
        return [];
      }
    },
    height: {
      type: Number,
      default: () => {
        return 350;
      }
    },
    //名單專區資訊
    categoryInfo: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      order: {
        fieldName: "name",
        asc: true
      },
      addressData: {},
      IndexIntegratedAddressModalOpen: false,
      checkAll: false,
      clickTarget: "",
      tableDataBackup: [],
      allIdData: [],
      selection: [],
      currentWidth: 0,
      is_iPad: is_iPad,
      iPadWidth: idmarkWidth,
      distinctid: [],
      selCust: [] //選取的客戶
    };
  },
  computed: {
    ...mapGetters(["UserInfo", "BaseUrl"]),
    isBox() {
      //判斷是否為box
      return this.UserInfo.userType === "box";
    }
  },
  watch: {
    tableData: function () {
      this.init();
    },
    clickTarget: function (target) {
      if (target == "clickAll" || target == "clickAll-again") {
        //點了全選checkbox
        if (this.checkAll) {
          //點了全選
          this.selection = [];
          this.selection = [...this.tableDataBackup];
        } else {
          //取消全選
          this.selection = [];
        }
      } else {
        //點了其他checkbox
        this.checkAll = this.selection.length == this.allIdData.length;
      }
      this.$emit("update", this.selection);
    }
  },
  methods: {
    ...mapActions(["setPageLock", "updateCustID"]),
    columnSorting(fieldName) {
      console.log(`>>>>> columnSorting:${fieldName} <<<<<`);
      //切換表頭圖案
      if (this.order.fieldName == fieldName) {
        this.order.asc = !this.order.asc;
      } else {
        console.log("change sort field");
        this.order.fieldName = fieldName;
        this.order.asc = true;
        console.log(this.order);
      }

      //data排序
      let sortOrder = -1;
      if (this.order.asc) {
        sortOrder = 1;
      }

      switch (fieldName) {
        case "ceplcdt": //投保日
        case "cenxpdt": //下次應繳日
          this.tableDataBackup = [];
          setTimeout(() => {
            this.tableDataBackup = [...this.tableData];
            this.tableDataBackup.sort(
              this.dateCompareFun(sortOrder, fieldName)
            );
            this.registerHanlink(); // 難字顯示
            if (this.checkAll) {
              this.selection = [];
              this.selection = [...this.tableDataBackup];
              this.$emit("update", this.selection);
            }
          }, 20);
          break;
        case "birthday": //生日
          this.tableDataBackup = [];
          setTimeout(() => {
            this.tableDataBackup = [...this.tableData];
            this.tableDataBackup.sort(
              this.sortCompareFun(sortOrder, "birthdaySort")
            );
            this.registerHanlink(); // 難字顯示
          }, 20);
          break;
        default:
          this.tableDataBackup = [];
          setTimeout(() => {
            this.tableDataBackup = [...this.tableData];
            this.tableDataBackup.sort(
              this.sortCompareFun(sortOrder, fieldName)
            );
            this.registerHanlink(); // 難字顯示
            if (this.checkAll) {
              this.selection = [];
              this.selection = [...this.tableDataBackup];
              this.$emit("update", this.selection);
            }
          }, 20);
      }
    },
    dateCompareFun(sortOrder, property) {
      return function (a, b) {
        let date_a = new Date(
          a[property] ? a[property] : "1880-01-01"
        ).getTime();
        let date_b = new Date(
          b[property] ? b[property] : "1880-01-01"
        ).getTime();
        let result = date_a < date_b ? -1 : 1;
        return result * sortOrder;
      };
    },
    sortCompareFun(sortOrder, property) {
      return function (a, b) {
        let result =
          a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
        return result * sortOrder;
      };
    },
    routerToCust(custID, custName) {
      if (this.isBox) {
        //若内嵌於Box, 將客戶資訊回傳給Box
        this.boxCustInfo(custID, custName);
      } else {
        this.updateCustID(custID);
        localStorage.CustID = custID;
        this.$router.push({ path: `/detail/CustID/tab/1` });
      }
    },
    openAddressModal(custId, custName) {
      //  打開整合地址
      queryBelowEstrangePolicyContactInfo(
        this.$store.state.userInfo.id,
        custId,
        custName
      ).then(result => {
        if (result && result.header.status == "200" && result.body) {
          let iaaData = result.body.detail || {};
          if (result.body.detail) {
            //整理顯示內容
            iaaData.mobile = iaaData.mobl_no || ""; //手機號碼
            iaaData.mobile_update = "";
            iaaData.homeTel =
              (iaaData.htel_area ? iaaData.htel_area + "-" : "") +
              (iaaData.htel_num ? iaaData.htel_num : "") +
              (iaaData.htel_ext ? "#" + iaaData.htel_ext : ""); //住家電話號碼
            iaaData.tel_h_update = "";
            iaaData.corpTel =
              (iaaData.ctel_area ? iaaData.ctel_area + "-" : "") +
              (iaaData.ctel_num ? iaaData.ctel_num : "") +
              (iaaData.ctel_ext ? "#" + iaaData.ctel_ext : ""); //公司電話號碼
            iaaData.tel_o_update = "";
            iaaData.addressData = "";
            iaaData.tel_p_update = "";
            iaaData.feeAdd = [
              iaaData.addr_p_postal_cd ? iaaData.addr_p_postal_cd.trim() : "",
              iaaData.addr_p_city_nm ? iaaData.addr_p_city_nm.trim() : "",
              iaaData.addr_p_line_1 ? iaaData.addr_p_line_1.trim() : "",
              iaaData.addr_p_line_2 ? iaaData.addr_p_line_2.trim() : ""
            ]; //收費地址
            iaaData.censusAdd = [
              iaaData.addr_h_postal_cd ? iaaData.addr_h_postal_cd.trim() : "",
              iaaData.addr_h_city_nm ? iaaData.addr_h_city_nm.trim() : "",
              iaaData.addr_h_line_1 ? iaaData.addr_h_line_1.trim() : "",
              iaaData.addr_h_line_2 ? iaaData.addr_h_line_2.trim() : ""
            ]; //戶籍地址
            iaaData.contactAdd = [
              iaaData.addr_c_postal_cd ? iaaData.addr_c_postal_cd.trim() : "",
              iaaData.addr_c_city_nm ? iaaData.addr_c_city_nm.trim() : "",
              iaaData.addr_c_line_1 ? iaaData.addr_c_line_1.trim() : "",
              iaaData.addr_c_line_2 ? iaaData.addr_c_line_2.trim() : ""
            ]; //聯絡地址
            iaaData.email_update_date = "";
            this.addressData = iaaData;
          }
        }
        this.addressData.isRemoteDocumentWarningShow = true;
        this.registerHanlink();
        this.panelOpen("IndexIntegratedAddressModalOpen");
      });
    },
    init() {
      console.log(">>>>> init <<<<<");
      this.checkAll = false;
      this.selection = [];
      this.tableDataBackup = this.tableData.map(ele => {
        return ele;
      });
      this.order.fieldName = "name";
      this.order.asc = true;
      this.registerHanlink(); // for 難字更新
    },
    callBoxVisit(data) {
      //連至Box排訪
      this.boxVisit(data, this.categoryInfo);
    }
  },
  mounted() {
    this.currentWidth =
      this.$el.clientWidth * (this.$el.clientWidth < 1250 ? 0.95 : 1);
    if (!is_iPad) {
      this.iPadWidth = "131";
    } else {
      this.iPadWidth = "148";
    }
  }
};
</script>

<style lang="scss" scoped>
.newTable thead tr,
.newTable tbody tr {
  display: table;
  width: 100%;
  table-layout: fixed;
  border-left: 0;
  border-right: 0;
  border-bottom: 0;

  td {
    word-break: break-all;
  }

  &.sorting,
  &.sorting_desc {
    position: relative;
    padding-right: 25px !important;

    &:before,
    &:after {
      content: "";
      position: absolute;
      width: 0px;
      height: 0px;
      display: block;
      top: 0;
      bottom: 0;
      right: 6px;
      margin: auto;
    }

    &:after {
      top: 18px;
      border-top: 6px solid transparentize(#027a39, 0.5);
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
      border-bottom: 6px solid transparent;
    }

    &:before {
      top: -13px;
      border-bottom: 6px solid transparentize(#027a39, 0.5);
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
      border-top: 6px solid transparent;
    }
  }

  &.sorting_asc:before {
    border-bottom: 6px solid transparentize(white, 0.5);
  }

  &.sorting_desc:after {
    border-top: 6px solid transparentize(white, 0.5);
  }

  &.no-sort:before,
  &.no-sort:after {
    display: none;
  }
}

.newTable tbody.block-height {
  display: block;
  height: 350px;
  overflow-y: scroll;
  border: 0 !important;
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    width: 17px;
    border: 0;
    box-shadow: none;
  }

  &::-webkit-scrollbar-track {
    box-shadow: none;
    border-radius: 0px;
    border: 0;
    background-color: #f5f5f5;
  }

  &::-webkit-scrollbar-thumb {
    width: 10px;
    border-radius: 20px;
    background-color: #555;
  }
}
</style>
